/**
 * @param input
 * @param options
 * @returns
 */
export const sanitizeInput = (
  input: string,
  options: {
    allowSpaces?: boolean
    allowNumbers?: boolean
    allowLetters?: boolean
    additionalAllowedChars?: string
  } = {}
): string => {
  const {
    allowSpaces = false,
    allowNumbers = true,
    allowLetters = true,
    additionalAllowedChars = '',
  } = options

  let baseChars = ''
  if (allowLetters) {
    baseChars += 'a-zA-ZÀ-ÖØ-öø-ÿ'
  }
  if (allowNumbers) {
    baseChars += '0-9'
  }
  const allowedChars = `[^${baseChars}${allowSpaces ? ' ' : ''}${additionalAllowedChars}]`
  const regex = new RegExp(`${allowedChars}`, 'g')
  return input.replace(regex, '')
}

export const SanitizePatterns = {
  username: (input: string) =>
    sanitizeInput(input, {
      additionalAllowedChars: '_\\.-',
    }),

  text: (input: string) =>
    sanitizeInput(input, {
      allowSpaces: true,
      additionalAllowedChars: "&,\\-_.'’",
    }),

  numbers: (input: string) =>
    sanitizeInput(input, {
      allowLetters: false,
      additionalAllowedChars: '.,',
    }),

  email: (input: string) => input,
}
